import { IonLabel } from '@ionic/react';

import Question from '@/components/profile/Question/Question';

import styles from './FaqList.module.scss';

export default function FaqList() {
  const dataInfo = [
    {
      title: '¿Qué hago para ponerme en contacto con mi asesor comercial? ',
      content:
        'Puedes ponerte en contacto con nosotros en el teléfono 91 216 12 12.',
    },
    {
      title: '¿Cuándo me abonan las financiaciones?',
      content: 'Las financiaciones se abonan de forma inmediata.',
    },
    {
      title: '¿Cuándo abona los recibos mi cliente?',
      content:
        'En operaciones con tarjeta el mismo día que financia, en el resto de operaciones el día 1.',
    },
    {
      title: '¿Qué importe mínimo y máximo puedo financiar?',
      content: 'Financiamos importes desde 150 a 10.000 €.',
    },
    {
      title: '¿Cómo sé cuáles son las tarifas que tengo para financiar?',
      content:
        'En Pepper siempre intentamos adaptarnos a las necesidades de tu cliente. Tu comercial te mantendrá informado en todo momento de las condiciones. Llama al 912161212.',
    },
    {
      title: '¿Tengo que enviar algún documento físico a Pepper?',
      content:
        'No, todo se hace de forma digital, nunca te vamos a pedir documentación física.',
    },
    // {
    //   title:
    //     '¿Qué horario tengo para tramitar y visualizar el detalle de las operaciones?',
    //   content:
    //     'Puedes realizar y consultar tus  solicitudes  las 24h del día los 365  días de año a través de nuestra Web.',
    // },
    // {
    //   title: '¿Dónde tiene que llamar mi cliente si tiene alguna consulta?',
    //   content:
    //     'Tu cliente se puede poner en contacto con Pepper a través de su área personal en https://www.clientespepper.com/ o por teléfono en el 91 216 13 50.',
    // },
    // {
    //   title: '¿Cómo puedo recuperar mi clave de acceso?',
    //   content:
    //     'Introduciendo tu usuario y clicando en "recordar contraseña" recibirás un correo con los pasos a seguir.',
    // },
    // {
    //   title:
    //     'Además de la Web, ¿puedo tramitar mis financiaciones por otro canal?',
    //   content:
    //     'Sí, puedes hacerlo descargándote nuestra APP "Pepper comercios" desde la store de tu móvil o tablet.',
    // },
  ];

  const operationsInfo = [
    {
      title: '¿Qué documentación me van a solicitar? ',
      content:
        'No te solicitaremos documentación hasta 1.000 € y a partir de 1.000 € sólo el DNI.',
    },
    {
      title: '¿Es necesario realizar un mínimo de financiaciones?',
      content:
        'No es necesario, pero es recomendable para poder mantener tu cuenta abierta.',
    },

    {
      title:
        '¿Qué requisitos son necesarios para financiar con tarjeta bancaria?',
      content:
        'Solamente necesitamos que tu cliente disponga de tarjeta de crédito o débito, email y un móvil.',
    },
    {
      title: '¿Qué requisitos se necesitan para financiar con IBAN?',
      content:
        'Tu cliente sólo necesita tener banca online de la cuenta donde tenga domiciliados sus ingresos y tener instalada la App del banco en su móvil.',
    },
  ];

  return (
    <div className={styles.faqListInfo}>
      <div className={styles.infoOne}>
        <div className={styles.infoTitles}>
          <IonLabel className={styles.infoText}>Preguntas Frecuentes</IonLabel>
          <IonLabel className={styles.descriptionText}>Hemos identificado algunas de las dudas más comunes, si no ves la tuya aquí resuelta, contacta con nosotros.</IonLabel>
        </div>
        <div className={styles.infoQuestions}>
          <p className={styles.questionsHeaderTitle}>Sobre tus datos</p>
          {dataInfo.map(({ title, content }, index) => <Question key={index} title={title} content={content} />)}
        </div>
        <div className={styles.infoQuestions}>
          <p className={styles.questionsHeaderTitle}>Sobre tus operaciones</p>
          {operationsInfo.map(({ title, content }, index) => <Question key={index} title={title} content={content} />)}
        </div>
      </div>
    </div>
  );
}
